import React from "react";
import PublicNavbar from "../../components/public/PublicNavbar";

const ShippingPolicy = () => {
    return (
        <div className="min-h-screen bg-[#FFFFFF] text-[#263746] font-sans">
            <PublicNavbar />

            <div className="bg-[#F7F5EF] border-b border-[#E5E7EB] py-12 px-6 text-center">
                <div className="max-w-4xl mx-auto">
                    <span className="text-[#E3B629] text-xs font-black tracking-[0.25em] uppercase block mb-1">
                        Logistics & Dispatch
                    </span>
                    <h1 className="text-3xl sm:text-4xl font-extrabold text-[#263746]">
                        Shipping & Delivery Policy
                    </h1>
                    <p className="text-[#687482] text-xs sm:text-sm mt-2">
                        LUMIGO PROJECTION SOLUTIONS • Fourlifters Private Limited • Commercial Equipment Transportation
                    </p>
                </div>
            </div>

            <div className="max-w-4xl mx-auto px-6 py-12 space-y-8 text-[#687482] text-xs sm:text-sm leading-relaxed">
                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        1. Order Lead Time & Custom Gobo Etching
                    </h2>
                    <p>
                        Unlike off-the-shelf retail products, commercial gobo projection systems frequently involve custom optical components and laser-etched dichroic glass gobos. Standard lead times include:
                    </p>
                    <ul className="list-disc list-inside space-y-1 text-[#687482]">
                        <li>Standard In-Stock Projector Hardware: Typically dispatched within 2 to 4 business days following payment confirmation.</li>
                        <li>Custom Glass Gobo Fabrication: High-precision laser etching and colour proofing typically requires 2 to 4 business days prior to dispatch.</li>
                        <li>High-Power Architectural Projects (200W–300W): Lead times are agreed specifically in the formal quotation.</li>
                    </ul>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        2. Domestic Shipping & Couriers
                    </h2>
                    <p>
                        We dispatch shipments pan-India utilizing reputed insured cargo carriers and surface express partners (e.g. Blue Dart, Delhivery, V-Trans, TCI Express) depending on unit weight and delivery urgency.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        3. Packaging & In-Transit Insurance
                    </h2>
                    <p>
                        All projectors are packaged in reinforced drop-tested cartons with high-density protective foam inserts to safeguard precision optical lenses, LED engines, and glass gobo carousels. Insured freight options are specified in your written quotation.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        4. Dispatch Tracking & Notifications
                    </h2>
                    <p>
                        Upon dispatch, tracking details, carrier airway bill (AWB) numbers, and consignment receipts are updated in your customer dashboard and communicated directly via email and WhatsApp.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        5. Questions on Delivery & Dispatch Desk
                    </h2>
                    <p className="font-semibold text-xs text-[#263746] leading-relaxed">
                        Fourlifters Private Limited (Brand: LUMIGO)<br />
                        E-21/22, Kaygee Engineering Premises, T Block, MIDC Bhosari, Pune, Maharashtra - 411026<br />
                        Email: fourlifters@gmail.com / sales@fourlifters.in | WhatsApp: +91 8087680893 | Website: www.fourlifters.in
                    </p>
                </section>
            </div>
        </div>
    );
};

export default ShippingPolicy;
